Intl = require 'intl'

Intl.__addLocaleData require('intl-locale-data')



// WEBPACK FOOTER //
// ./app/scripts/entry/intl-polyfill.coffee